import { BodyPrimary, LabelMini } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { ReactNode } from 'react';

type ItemWrapperProps = {
    isLoggedIn?: boolean;
    label: ReactNode;
    onUnlockItemClick?: () => void;
    requiresLogin?: boolean;
    unlockTestId?: string;
    value: ReactNode;
};

export const DetailsInfoItem = ({
    isLoggedIn,
    label,
    onUnlockItemClick,
    requiresLogin,
    unlockTestId = 'unlock-button',
    value,
}: ItemWrapperProps) => {
    return (
        <div className="flex w-fit flex-col gap-2xs bg-background-secondary p-sm">
            <LabelMini
                className="whitespace-nowrap"
                color="secondary"
            >
                {label}
            </LabelMini>
            {requiresLogin && !isLoggedIn ? (
                <InlineButton
                    data-testid={unlockTestId}
                    onClick={onUnlockItemClick}
                >
                    <FormattedMessage id="priceResultsPage.unlock" />
                </InlineButton>
            ) : (
                <BodyPrimary>{value}</BodyPrimary>
            )}
        </div>
    );
};
